<template>
  <v-container
    grid-list-md
    fluid
    class="pa-2"
  >
    <v-layout
      row
      wrap
    >
      <v-container
        grid-list-md
        fluid
        class="pa-1"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
          >
            <v-card class="max-shadow">
              <v-card-title>
                <div class="title-2">
                  Billing Settings
                </div>
                <v-spacer />
                <v-card-actions>
                  <v-btn
                    color="primary"
                    flat
                    @click="saveBillingSettings"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-divider />
              <v-form ref="billingForm">
                <v-subheader>
                  GST
                </v-subheader>
                <div class="px-3">
                  <v-text-field
                    v-model="billingSettings.GSTIN"
                    outline
                    :rules="[(v) => {return validateGSTIN(v);}]"
                    label="GST Indentification Number"
                  />
                </div>
                <v-subheader>Address</v-subheader>
                <div class="px-3 pb-3">
                  <v-text-field
                    v-model="billingSettings.address.company"
                    :rules="[v => !!v || 'Company is required']"
                    label="Company"
                    required
                  />
                  <v-text-field
                    v-model="billingSettings.address.line1"
                    :rules="[v => !!v || 'Address Line 1 is required']"
                    label="Address Line 1"
                    required
                  />
                  <v-text-field
                    v-model="billingSettings.address.line2"
                    label="Address Line 2"
                  />
                  <v-text-field
                    v-model="billingSettings.address.city"
                    :rules="[v => !!v || 'City is required']"
                    label="City"
                    required
                  />
                  <v-text-field
                    v-model="billingSettings.address.state"
                    :rules="[v => !!v || 'Pincode is required']"
                    label="State"
                    required
                    disabled
                  />
                  <v-text-field
                    v-model="billingSettings.address.pincode"
                    :rules="[v => !!v || 'Pincode is required']"
                    label="Pincode"
                    mask="######"
                    required
                  />
                </div>
              </v-form>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            sm6
          >
            <v-card class="max-shadow">
              <v-card-title>
                <div class="title-2">
                  Invoice Settings
                </div>
                <v-spacer />
                <v-card-actions>
                  <v-btn
                    color="primary"
                    flat
                    @click="saveInvoiceSettings"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-divider />
              <v-form
                ref="invoiceForm"
                class="pa-2"
              >
                <v-textarea
                  v-model="invoiceSettings.customerNotes"
                  label="Customer Notes"
                  hint="will be displayed on invoice"
                  persistent-hint
                  outline
                />
                <v-textarea
                  v-model="invoiceSettings.tnc"
                  label="Terms & Conditions"
                  hint="will be displayed on invoice"
                  persistent-hint
                  outline
                />
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :right="true"
      :timeout="4000"
      :top="true"
      :color="snackColor"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';

export default {
  name: 'MaxTowersSettings',
  data() {
    return {
      billingSettings: {
        GSTIN: null,
        address: {
          company: null,
          line1: null,
          line2: null,
          city: 'Noida',
          state: 'Uttar Pradesh',
          pincode: 201301
        }
      },
      invoiceSettings: {
        customerNotes: null,
        tnc: null
      },
      snackbar: false,
      snackColor: 'success',
      snackText: ''
    };
  },
  created() {
    this.$store.commit('setToolbarTitle', {
      toolbarTitle: 'Max Towers Settings'
    });
  },
  mounted() {
    firestore
      .doc('settings/maxTowers')
      .get()
      .then(settings => {
        this.billingSettings = settings.data().billingSettings;
        this.invoiceSettings = settings.data().invoiceSettings;
      });
  },
  methods: {
    validateGSTIN(val) {
      if (!val) {
        return true;
      }
      if (val && /^\w\d\S{13}$/.test(val)) {
        return true;
      }
      return 'Invalid GSTIN';
    },

    saveBillingSettings() {
      if (!this.$refs.billingForm.validate()) return;

      firestore
        .doc('settings/maxTowers')
        .update({
          billingSettings: this.billingSettings
        })
        .then(() => {
          this.snackText = 'Billing settings are saved';
          this.snackbar = true;
        })
        .catch(error => {
          this.snackColor = 'error';
          this.snackText = 'Error in saving billing settings are saved';
          this.snackbar = true;
          console.log(error);
        });
    },

    saveInvoiceSettings() {
      if (!this.$refs.invoiceForm.validate()) return;

      firestore
        .doc('settings/maxTowers')
        .update({
          invoiceSettings: this.invoiceSettings
        })
        .then(() => {
          this.snackText = 'Invoice settings are saved';
          this.snackbar = true;
        })
        .catch(error => {
          this.snackColor = 'error';
          this.snackText = 'Error in saving invoice settings are saved';
          this.snackbar = true;
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
</style>